<template>
  <Modal v-model="sessionFeedbackAll" :hideModalHeader="true">
    <section class="-mt-8 w-full">
      <button
        @click="handleSessionFeedbackAllModal(false)"
        class="relative w-full"
      >
        <div class="absolute mt-1 right-0 text-gray-dark">
          <X />
        </div>
      </button>

      <div class="mt-4" v-if="data && data.length">
        <div class="flex">
          <Star class="mt-2 px-1" />
          <span class="text-xl text-center font-medium text-gray-dark">{{
            averageRating
          }}</span>
          <span class="ml-2 text-xl text-center font-medium text-gray-dark"
            >({{ data.length }} reviews)</span
          >
        </div>

        <div v-for="(d, i) in data" :key="i" class="py-3 rounded">
          <div v-if="i != data.length - 1">
            <div class="flex items-center justify-between border-b">
              <div class="flex items-center mb-18">
                <Avatar :src="baseUrlSrc(d.thumbnail_url)" classStr="a-42" />
                <div class="ml-2">
                  <div class="flex">
                    <p class="text-gray-dark text-sm font-bold capitalize">
                      {{ d.name }}
                    </p>
                    <span class="pl-1" style="color: grey"> &#x2027;</span>
                    <span
                      class="pl-1 text-gray-light text-xs font-medium mt-arrow"
                    >
                      {{ handleCreatedAt(d.created_at) }}</span
                    >
                  </div>

                  <p class="">
                    {{ d.body }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="i == data.length - 1">
            <div class="flex items-center justify-between">
              <div class="flex items-center mb-18">
                <Avatar :src="baseUrlSrc(d.thumbnail_url)" classStr="a-42" />
                <div class="ml-2">
                  <div class="flex">
                    <p class="text-gray-dark text-sm font-bold capitalize">
                      {{ d.name }}
                    </p>
                    <span class="pl-1" style="color: grey"> &#x2027;</span>
                    <span class="pl-1 text-gray-light text-xs font-medium">
                      {{ handleCreatedAt(d.created_at) }}
                    </span>
                  </div>

                  <p class="">
                    {{ d.body }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Modal>
</template>

<script>
import { Modal, Avatar } from "@/components/t-components";
import { X, Star } from "@/components/icons";

export default {
  name: "SessionFeedbackAll",
  components: {
    Modal,
    Avatar,
    X,
    Star,
  },
  props: {
    sessionFeedbackAll: Boolean,
    handleSessionFeedbackAllModal: Function,
    data: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      averageRating: "",
    };
  },
  methods: {
    handleCancel() {
      this.modalOpen = false;
    },

    handleEdit() {
      this.modalOpen = false;
      this.$emit("data", true);
    },
  },
  async created() {
    if (this.data) {
      let totalRating = 0;
      let l = this.data.length;
      for (let i = 0; i < l; i++) {
        totalRating += this.data[i].rating;
      }
      this.averageRating = totalRating / l;
      this.averageRating = this.averageRating.toFixed(2);
      return this.averageRating;
    }
  },
};
</script>

<style lang="scss" scoped>
.mb-18 {
  margin-bottom: 18px;
}
</style>